import dynamic from "next/dynamic";
import { useState } from "react";
import Image from "next/future/image";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "./styles/style.module.scss";
// import ConsultPopup from "@/components/Shared/ConsultPopup/ConsultPopup";
const ConsultPopup = dynamic(
  () => import("@/components/Shared/ConsultPopup/ConsultPopup"),
  {
    loading: () => <p>Loading...</p>,
  }
);
const Hero = ({ bannerOne }) => {
  const { locale } = useIntl();
  const [isConsultPopUpVisible, setIsConsultPopUpVisible] = useState(false);
  // Toggle ConsultPopup visibility
  const toggleConsultPopUp = () => {
    setIsConsultPopUpVisible((prev) => !prev);
  };

  // Extract content for readability and performance
  const title = bannerOne?.title?.[locale];
  const subTitle = bannerOne?.subTitle?.[locale];
  const description = bannerOne?.description?.[locale]?.replace(
    /<\/?[^>]+(>|$)/g,
    ""
  );

  return (
    <div className={`${styles["main-hero"]} main-hero`}>
      <div className="container-div">
        <div className="overlay" />

        <div className="one-slider flex-center">
          <Image
            src={bannerOne?.backgroundImage}
            alt="Banner"
            width={1420}
            height={1130}
            priority={false}
            loading="lazy"
          />
          <div className="content flex-center">
            <h2 className="subTitle">{subTitle}</h2>
            <h3 className="title">{title}</h3>
            <p className="description">{description}</p>
            <div className="btns flex-center">
              <button onClick={toggleConsultPopUp} className="btn-md">
                <FormattedMessage id="bookAConsult" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {isConsultPopUpVisible && (
        <ConsultPopup
          show={isConsultPopUpVisible}
          setShow={setIsConsultPopUpVisible}
          handleToggle={toggleConsultPopUp}
        />
      )}
    </div>
  );
};

export default Hero;
